import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { createStudentList, createStudentListCategory, deleteStudentList, deleteStudentListCategory, getStudentListCategories, getStudentLists, updateStudentList, updateStudentListCategory } from './api'
import type { SaveStudentList } from './types'
import { useStaffOverrideStore } from '@stores/useStaffOverrideStore'

export const useStudentLists = () => {
  const staffOverride = useStaffOverrideStore(state => state.override?.trim() || null)
  return useQuery({ queryKey: ['student-lists', staffOverride], queryFn: getStudentLists })
}
export const useStudentListCategories = () => useQuery({ queryKey: ['student-lists', 'categories'], queryFn: getStudentListCategories })
export const useSaveStudentList = () => {
  const client = useQueryClient()
  return useMutation({ mutationFn: (input: { id?: number; value: SaveStudentList }) => input.id ? updateStudentList(input.id, input.value) : createStudentList(input.value), onSuccess: () => client.invalidateQueries({ queryKey: ['student-lists'] }) })
}
export const useDeleteStudentList = () => {
  const client = useQueryClient()
  return useMutation({ mutationFn: deleteStudentList, onSuccess: () => client.invalidateQueries({ queryKey: ['student-lists'] }) })
}
export const useSaveStudentListCategory = () => {
  const client = useQueryClient()
  return useMutation({ mutationFn: (input: { id?: number; value: { name: string; description?: string } }) => input.id ? updateStudentListCategory(input.id, input.value) : createStudentListCategory(input.value), onSuccess: () => { client.invalidateQueries({ queryKey: ['student-lists', 'categories'] }); client.invalidateQueries({ queryKey: ['student-lists'] }) } })
}
export const useDeleteStudentListCategory = () => {
  const client = useQueryClient()
  return useMutation({ mutationFn: deleteStudentListCategory, onSuccess: () => { client.invalidateQueries({ queryKey: ['student-lists', 'categories'] }); client.invalidateQueries({ queryKey: ['student-lists'] }) } })
}
